import React, { Component } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "./home";
import ChangePassword from "./changePassword";
import Notfound from "./notfound";
import ApplicationInfo from "../mainComponents/applicationInfo";
import UserManagement from "../contentComponents/system/usermanagement";
import RoleManagement from "../contentComponents/system/rolemanagement";
import SystemParameters from "../contentComponents/system/systemparameters";
import sysJwt from "../../utils/sysJwt";
import Reports from "../contentComponents/reports/reports";
import ExecuteReport from "../contentComponents/reports/executeReport";
import AgentGiftsCategories from "../contentComponents/gifts/agentGiftsCategories";
import AgentGifts from "../contentComponents/gifts/agentGifts";
import PipefitterGiftsCategories from "../contentComponents/gifts/pipefitterGiftsCategories";
import PipefitterGifts from "../contentComponents/gifts/pipefitterGifts";
import Agents from "../contentComponents/agents/agents";
import AgentsBills from "../contentComponents/agents/agentsBills";
import AgentsRequests from "../contentComponents/agents/agentsRequests";
import Pipefitters from "../contentComponents/pipefitters/pipefitters";
import PipefittersTransfer from "../contentComponents/pipefitters/pipefittersTransfer";
import PipefittersRequests from "../contentComponents/pipefitters/pipefittersRequests";
import MobileUser from "../contentComponents/users/mobileUsers";
import Agencies from "../contentComponents/agencies/agencies";
import AgenciesProducts from "../contentComponents/agencies/agenciesProducts";
import Notifs from "../contentComponents/definitions/notifs";
import Slider from "../contentComponents/definitions/slider";

class AppRoutes extends Component {
  state = {};
  render() {
    return (
      <Routes>
        {sysJwt.isAuthorized(["CAEC"]) && (
          <Route
            path="/reports"
            element={
              <Reports
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CAEC", "CAF0"]) && (
          <Route
            path="/executereport"
            element={
              <ExecuteReport
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CABE"]) && (
          <Route
            path="/usermanagement"
            element={
              <UserManagement
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CAC5"]) && (
          <Route
            path="/rolemanagement"
            element={
              <RoleManagement
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CAD5"]) && (
          <Route
            path="/systemparameters"
            element={
              <SystemParameters
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CAF3"]) && (
          <Route
            path="/agentgiftscategories"
            element={
              <AgentGiftsCategories
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CAF7"]) && (
          <Route
            path="/agentgifts"
            element={
              <AgentGifts
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CAFB"]) && (
          <Route
            path="/pipefittergiftscategories"
            element={
              <PipefitterGiftsCategories
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CAFF"]) && (
          <Route
            path="/pipefittergifts"
            element={
              <PipefitterGifts
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CB11"]) && (
          <Route
            path="/agents"
            element={
              <Agents
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CB14"]) && (
          <Route
            path="/agentsbills"
            element={
              <AgentsBills
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CB16"]) && (
          <Route
            path="/agentsrequests"
            element={
              <AgentsRequests
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CB1A"]) && (
          <Route
            path="/pipefitters"
            element={
              <Pipefitters
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CB1B"]) && (
          <Route
            path="/pipefitterstransfer"
            element={
              <PipefittersTransfer
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CB1C"]) && (
          <Route
            path="/pipefittersrequests"
            element={
              <PipefittersRequests
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CB1D"]) && (
          <Route
            path="/mobileuser"
            element={
              <MobileUser
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}

        {sysJwt.isAuthorized(["CB03"]) && (
          <Route
            path="/agencies"
            element={
              <Agencies
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CB07"]) && (
          <Route
            path="/agenciesproducts"
            element={
              <AgenciesProducts
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}

        {sysJwt.isAuthorized(["CB0E"]) && (
          <Route
            path="/notifs"
            element={
              <Notifs
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}
        {sysJwt.isAuthorized(["CB0B"]) && (
          <Route
            path="/slider"
            element={
              <Slider
                inModalMode={false}
                isLoading={this.props.isLoading}
                updateIsLoading={this.props.updateIsLoading}
              />
            }
          />
        )}

        <Route
          path="/applicationinfo"
          element={
            <ApplicationInfo
              inModalMode={true}
              isLoading={this.props.isLoading}
              updateIsLoading={this.props.updateIsLoading}
            />
          }
        />
        <Route
          path="/changepassword"
          element={
            <ChangePassword
              inModalMode={true}
              isLoading={this.props.isLoading}
              updateIsLoading={this.props.updateIsLoading}
            />
          }
        />
        <Route
          path="/home"
          element={<Home updateIsLoading={this.props.updateIsLoading} />}
        />
        <Route path="/notfound" element={<Notfound />} />
        <Route
          path="*"
          element={<Navigate to="/dashboard/notfound" replace />}
        />
      </Routes>
    );
  }
}

export default AppRoutes;
